export default __webpack_public_path__ + "static/media/up-arrow-selector-quickship.da080b4f.svg";